import "./ProgressLevel.scss";

const STEP = 2500; // стільки ₴ поповнень відкривають наступний рівень (+1% бонусу)
const MAX_BONUS = 5;

const ProgressLevel = ({user}) => {
    const total = Math.max(0, Number(user.currentAmount) || 0)
    const maxed = (Number(user.personalBonus) || 0) >= MAX_BONUS

    // раніше тут віднімалось 5000 × ⌊сума/2500⌋, і після першого рівня прогрес ставав від'ємним
    const inLevel = maxed ? STEP : total % STEP
    const percent = Math.round((inLevel / STEP) * 100)

    return (
        <div className="pb-progress">
            <div className="pb-progress-head">
                <span className="pb-muted">{ maxed ? "Максимальний рівень" : "До наступного рівня" }</span>
                <span className="pb-progress-percent">{ percent }%</span>
            </div>
            <div className="pb-bar">
                <div className="pb-bar-fill" style={{ width: `${percent}%` }} />
            </div>
            { !maxed &&
                <div className="pb-progress-labels">
                    <span>{ inLevel } ₴</span>
                    <span>ще { STEP - inLevel } ₴ із { STEP } ₴</span>
                </div>
            }
        </div>
    );
};

export default ProgressLevel;
